import { render } from "./MyTeachersTabs.vue?vue&type=template&id=4f44579f&scoped=true"
import script from "./MyTeachersTabs.vue?vue&type=script&lang=js"
export * from "./MyTeachersTabs.vue?vue&type=script&lang=js"

import "./MyTeachersTabs.vue?vue&type=style&index=0&id=4f44579f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f44579f"]])

export default __exports__